import React, { useEffect, useState } from "react";
import { Button, Col, Flex, InputNumber, Row } from "antd";
import api from "../../api";
import Loader from "../../components/spin/Loader";
import { useAuth } from "../../store/context/AuthContext";

const Dashboard = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  const { user } = useAuth();

  const fetchStats = async () => {
    setLoading(true);
    const res = await api.get_stats();
    console.log("dash --->", res);
    if (res.status === 200) {
      setData(res.data.data);
    } else {
      // console.error("Error fetching stats:", res);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchStats();
  }, []);

  const cellStyle = {
    background: "#f5f5f5",
    padding: "24px",
    textAlign: "center",
    borderRadius: 8,
    border: "1px solid #e0e0e0",
  };

  const [noatLimit, setNoatLimit] = useState(10);
  const [noatLoading, setNoatLoading] = useState(false);

  const runNoat = async () => {
    try {
      setNoatLoading(true);
      const res = await api.run_noat({ limit: noatLimit });

      if (res.status === 200) {
        fetchStats(); // статистик refresh
      }
    } catch (err) {
      console.error("NOAT error", err);
    } finally {
      setNoatLoading(false);
    }
  };

  if (loading) return <Loader />;

  return (
    <Flex
      vertical
      align="flex-start"
      justify="flex-start"
      style={{ width: "100%", height: "100%" }}
    >
      <Row gutter={[16, 16]} style={{ width: "100%" }}>
        <Col xs={24} sm={12} md={8}>
          <div style={cellStyle}>
            <h4>Нийт сугалаа</h4>
            <p style={{ fontSize: "30px" }}>{data.totalLotteries}</p>
          </div>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <div style={cellStyle}>
            <h4>Нийт үүссэн сугалааны дугаар</h4>
            <p style={{ fontSize: "30px" }}>{data.totalNumbers}</p>
          </div>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <div style={cellStyle}>
            <h4>Нийт оролцогчид</h4>
            {/* <p style={{ fontSize: "30px" }}>{data.totalParticipants}</p> */}
          </div>
        </Col>
      </Row>

      {user?.email === "btr.munkhjin@gmail.com" && (
        <Row gutter={[16, 16]} style={{ width: "100%", marginTop: 24 }}>
          <Col xs={24} md={8}>
            <div style={cellStyle}>
              <InputNumber
                min={1}
                max={100}
                value={noatLimit}
                onChange={setNoatLimit}
                style={{ width: "100%", marginBottom: 12 }}
              />

              <Button
                type="primary"
                loading={noatLoading}
                onClick={runNoat}
                block
              >
                NOAT илгээх
              </Button>
            </div>
          </Col>
        </Row>
      )}
    </Flex>
    // <Flex
    //   vertical
    //   align="center"
    //   justify="center"
    //   style={{ width: "100%", height: "100%" }}
    // >
    //   Тун удахгүй
    // </Flex>
  );
};

export default Dashboard;
